/**
 * Enum for agent permission keys.
 * @readonly
 * @example PermissionKeys 
 */
export enum PermissionKeys{
  AGENT_SOFTPHONE = "AgentSoftPhone",
  AGENT_PHONE = "AgentPhone",
  AGENT_STATION = "AgentStation",
  AGENTLEG_AUTOACCEPT = 'AgentSoftPhoneAutoAccept',
  HIDE_CREATE_COMMITMENTS = 'HideCreateCommitments'
}